import React from "react";
import { ICustomerRelatedAccount } from "../../../../redux/customer/customer.types";
import { useDispatchWrapper } from "../../../../hooks";
import { useFormik } from "formik";
import { addCustomerRelAccountlAsync } from "../../../../redux/customer/customerActions";
import { Dialog } from "../../../../components/Dialogs/Dialog";
import { Grid, Typography } from "@mui/material";
import { CustomFormLabel } from "../../../../components/formsComponents";
import { CustomerAutoSearch } from "../../../../components/AutoCompleteSearches/CustomerAutoSearch";

interface ICustomerRelDialogProps {
    open: boolean;
    data: ICustomerRelatedAccount;
    onClose: () => void;
    onComplete: () => void;
}

export const CustomerRelDialog: React.FC<ICustomerRelDialogProps> = (props) => {
  const { open, data, onClose,onComplete } = props;

 const [saveLoading, setSaveLoading] = React.useState(false);

  const dispatch = useDispatchWrapper();
  const { values, handleSubmit, setFieldValue } = useFormik({
    initialValues: data,
    validate: (values) => {
      const errors: any = {};
      return errors;
    },
    onSubmit: async (values) => {
      setSaveLoading(true);
      dispatch(
        addCustomerRelAccountlAsync(
          {
            ...values,
          },data, true,
          (isSuccess) => {
            if(isSuccess){
            onComplete();
            }
            setSaveLoading(false);
          }
        )
      );
    },
  });

  return (
    <Dialog
      open={open}
      title="Create/Edit Related Account"
      onClose={onClose}
      size="sm"
      fullWidth={true}
      contentWrappedWithForm={{ onSubmit: handleSubmit }}
      actions={[
        { type: "button", label: "Close", variant: "text", onClick: onClose },
        {
          type: "submit",
          label: "Save",
          variant: "contained",
          disabled: saveLoading,
        },
      ]}
    >
      <Grid container spacing={1}>
        <Grid item xs={12}>
            <CustomerAutoSearch
              label="Cross Reference ID"
              // disabled={isUpdate}
              value={values.cross_reference_id}
              onSelect={(newValue) => {
                // console.log("new value",newValue)
                setFieldValue("cross_reference_id", newValue.customer_id);
                setFieldValue("relative_name", newValue.customer_name + " (" + newValue.customer_code + ")");
              }}
            />
        </Grid>
        <Grid item xs={12}>
          <CustomFormLabel>Name</CustomFormLabel>
          <Typography variant="h5">{values.relative_name}</Typography>
        </Grid>
      </Grid>
    </Dialog>
  );
};
